import type { AssistantUsageLogText } from "@/locales/assistant-usage-log";
import type {
	UsageLogStatus,
	UsageLogVendor,
} from "@/types/ai-assistant-usage-log";

/** Logika murni tampilan log penggunaan penyedia: label, warna lencana, format angka. */

export const VENDOR_COLOR: Record<UsageLogVendor, string> = {
	claude: "violet",
	chatgpt: "teal",
	unknown: "gray",
};

export const STATUS_COLOR: Record<UsageLogStatus, string> = {
	ok: "green",
	error: "red",
};

/** Nama vendor untuk lencana; `unknown` = pesan sebelum M5 atau model tak dikenal. */
export function vendorLabel(
	vendor: UsageLogVendor,
	t: AssistantUsageLogText,
): string {
	if (vendor === "claude") return t.vendorClaude;
	if (vendor === "chatgpt") return t.vendorChatgpt;
	return t.vendorUnknown;
}

export function statusLabel(
	status: UsageLogStatus,
	t: AssistantUsageLogText,
): string {
	return status === "error" ? t.statusError : t.statusOk;
}

const locale = (lang: "id" | "en") => (lang === "en" ? "en-US" : "id-ID");

/** Angka token/jumlah; null (tidak dilaporkan penyedia) → tanda hubung. */
export function formatCount(
	n: number | null | undefined,
	lang: "id" | "en" = "id",
): string {
	return n === null || n === undefined ? "-" : n.toLocaleString(locale(lang));
}

/** Latensi milidetik → detik dengan satu desimal; null → tanda hubung. */
export function formatLatency(
	ms: number | null,
	lang: "id" | "en" = "id",
): string {
	if (ms === null) return "-";
	const MS_PER_SECOND = 1000;
	return `${(ms / MS_PER_SECOND).toLocaleString(locale(lang), {
		maximumFractionDigits: 1,
	})} s`;
}

/** Porsi vendor (0–100) apa adanya dari server, diformat sesuai bahasa. */
export function formatPercent(
	percent: number,
	lang: "id" | "en" = "id",
): string {
	return percent.toLocaleString(locale(lang), { maximumFractionDigits: 1 });
}
